
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.813 4.031c.837 0 1.648.335 2.281.969a3.251 3.251 0 010 4.594v.031l-12.688 12.5-.5.469c-.124.793-.46 1.572-1.063 2.188l-.031.031c-1.318 1.318-3.898 3.188-7.813 3.188H3.155l1-1.563c.967-1.474 1.37-2.804 1.688-4s.479-2.31 1.313-3.219a3.647 3.647 0 012.031-1.125l.625-.594L22.5 5a3.287 3.287 0 012.313-.969zm0 1.969c-.313 0-.64.14-.906.406l-9.063 8.906 1.813 1.813 9.031-8.938c.533-.533.533-1.248 0-1.781-.267-.267-.562-.406-.875-.406zM13.406 16.719l-1.5 1.469 1.813 1.813 1.5-1.469zm-3.437 3.312c-.506-.014-.997.153-1.344.531-.267.291-.511 1.152-.844 2.406-.216.814-.55 1.794-1.031 2.844 2.249-.421 3.787-1.537 4.656-2.406.827-.827.808-2.069.031-2.781a2.303 2.303 0 00-1.469-.594z"}})])
          )
        }
      }
    